import { isNil } from 'lodash';

export function isLowCodeViewTemplate({
  viewTemplate,
}: {
  viewTemplate?: MBAPI.ViewTemplate;
}): boolean {
  switch (viewTemplate?.subtype) {
    case 'TABLE':
    case 'LIST':
      return false;
    case 'CALENDAR':
      return isNil(viewTemplate.calendarDateComponentId);
    case 'BOARD':
      return !viewTemplate.customSortingEnabled;
    default:
      return true;
  }
}
